var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { DataTokenType, HeaderFooterTokenType } from './TokenTypes';
// there are overlap between the HeaderFooterTokenType and DataTokenType, but we want to
// be explicit that we are considering/including both here.
export default __assign((_a = {},
    _a[HeaderFooterTokenType.NEWLINE] = '\n',
    _a[HeaderFooterTokenType.NEWLINE_MICROSOFT] = '\r\n',
    _a[HeaderFooterTokenType.TAB] = '\t',
    _a[HeaderFooterTokenType.COMMA] = ',',
    _a[HeaderFooterTokenType.SPACE] = ' ',
    _a), (_b = {},
    _b[DataTokenType.NEWLINE] = '\n',
    _b[DataTokenType.NEWLINE_MICROSOFT] = '\r\n',
    _b[DataTokenType.TAB] = '\t',
    _b[DataTokenType.COMMA] = ',',
    _b[DataTokenType.SPACE] = ' ',
    _b));
